
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/base/Header';
import Footer from '../../components/base/Footer';
import ProductCard from '../../components/base/ProductCard';
import { updateSEO, seoData, getBaseURL } from '../../utils/seo';

function HomePage() {
  // SEO effect
  useEffect(() => {
    updateSEO({
      ...seoData.home,
      canonical: `${getBaseURL()}/`,
      ogTitle: seoData.home.title,
      ogDescription: seoData.home.description,
      ogImage: `${getBaseURL()}/og-image.jpg`
    });
  }, []);

  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('All');

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const filters = ['All', 'New In', 'Clothing', 'Bags', 'Accessories', 'Watches'];

  const featuredProducts = [
    {
      id: '1',
      image: 'https://public.readdy.ai/ai/img_res/308bd99d676c0d4dd3320d0a8a48cc7e.jpg.1%20quality%2C%20high-end%20menswear%20fashion%20photography%2C%20sophisticated%20fabric%20texture%20with%20emerald%20green%20accents%2C%20professional%20product%20photography%20on%20white%20background%2C%20luxury%20brand%20aesthetic%20with%20golden%20details&width=400&height=500&seq=dluxmen-polo-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Polo Shirt Super Clone 1.1',
      price: 'R$ 189,90',
      originalPrice: 'R$ 249,90',
      isNew: true
    },
    {
      id: '2',
      image: 'https://readdy.ai/api/search-image?query=luxury%20italian%20shorts%20premium%20menswear%2C%20high-quality%20fabric%20with%20sophisticated%20texture%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20style%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-shorts-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Italian Shorts Premium',
      price: 'R$ 159,90',
      isNew: true
    },
    {
      id: '3',
      image: 'https://readdy.ai/api/search-image?query=luxury%20menswear%20set%20complete%20outfit%2C%20premium%20fabric%20quality%20with%20sophisticated%20styling%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20ensemble%20with%20emerald%20green%20accents&width=400&height=500&seq=dluxmen-set-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Luxury Complete Set',
      price: 'R$ 349,90',
      originalPrice: 'R$ 449,90'
    },
    {
      id: '4',
      image: 'https://readdy.ai/api/search-image?query=luxury%20premium%20leather%20bag%20for%20men%2C%20sophisticated%20black%20leather%20with%20golden%20hardware%20details%2C%20professional%20product%20photography%20on%20white%20background%2C%20high-end%20masculine%20accessories%20with%20emerald%20green%20brand%20elements&width=400&height=500&seq=dluxmen-bag-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Premium Leather Bag',
      price: 'R$ 289,90'
    },
    {
      id: '5',
      image: 'https://readdy.ai/api/search-image?query=luxury%20ETA%20movement%20watch%20for%20men%2C%20sophisticated%20timepiece%20with%20premium%20materials%2C%20professional%20product%20photography%20on%20white%20background%2C%20elegant%20masculine%20watch%20with%20emerald%20green%20brand%20accents&width=400&height=500&seq=dluxmen-watch-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'ETA Movement Watch',
      price: 'R$ 599,90',
      originalPrice: 'R$ 799,90',
      isNew: true
    },
    {
      id: '6',
      image: 'https://readdy.ai/api/search-image?query=luxury%20cravejado%20accessories%20for%20men%2C%20premium%20jewelry%20with%20sophisticated%20design%2C%20professional%20product%20photography%20on%20white%20background%2C%20elegant%20masculine%20accessories%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-accessory-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Cravejado Accessories',
      price: 'R$ 129,90'
    },
    {
      id: '7',
      image: 'https://readdy.ai/api/search-image?query=luxury%20GBM%20style%20plain%20shirt%20for%20men%2C%20premium%20fabric%20quality%20with%20sophisticated%20cut%2C%20professional%20fashion%20photography%20on%20white%20background%2C%20elegant%20masculine%20shirt%20with%20emerald%20green%20brand%20accents&width=400&height=500&seq=dluxmen-shirt-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'GBM Style Plain Shirt',
      price: 'R$ 149,90'
    },
    {
      id: '8',
      image: 'https://readdy.ai/api/search-image?query=luxury%20premium%20sneakers%20for%20men%2C%20sophisticated%20design%20with%20high-quality%20materials%2C%20professional%20product%20photography%20on%20white%20background%2C%20elegant%20masculine%20footwear%20with%20emerald%20green%20brand%20details&width=400&height=500&seq=dluxmen-sneaker-1&orientation=portrait',
      brand: 'DLUXMEN',
      name: 'Premium Sneakers',
      price: 'R$ 259,90',
      originalPrice: 'R$ 329,90'
    }
  ];

  const collections = [
    {
      title: 'Italian Collection',
      subtitle: 'Elegância Italiana Autêntica',
      image: 'https://readdy.ai/api/search-image?query=luxury%20italian%20menswear%20collection%20banner%2C%20sophisticated%20fabric%20textures%20with%20emerald%20green%20and%20gold%20accents%2C%20elegant%20masculine%20fashion%20photography%2C%20premium%20brand%20aesthetic%20with%20dramatic%20lighting%20and%20shadows&width=600&height=400&seq=dluxmen-italian-collection&orientation=landscape',
      link: '/italian'
    },
    {
      title: 'Line 1.1',
      subtitle: 'Super Clone Premium',
      image: 'https://readdy.ai/api/search-image?query=luxury%20line%201.1%20super%20clone%20menswear%20collection%2C%20premium%20quality%20fabric%20with%20sophisticated%20styling%2C%20professional%20fashion%20photography%20with%20emerald%20green%20brand%20elements%2C%20high-end%20masculine%20aesthetic&width=600&height=400&seq=dluxmen-line11-collection&orientation=landscape',
      link: '/line11'
    },
    {
      title: 'Line 1.2',
      subtitle: 'Exclusividade Máxima',
      image: 'https://readdy.ai/api/search-image?query=luxury%20line%201.2%20exclusive%20menswear%20collection%2C%20premium%20materials%20with%20sophisticated%20design%2C%20professional%20fashion%20photography%20with%20emerald%20green%20and%20gold%20accents%2C%20elegant%20masculine%20luxury%20aesthetic&width=600&height=400&seq=dluxmen-line12-collection&orientation=landscape',
      link: '/line12'
    }
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F8F8F8', fontFamily: 'Montserrat, sans-serif' }}>
      <Header />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=luxury%20textile%20weaving%20machines%20in%20premium%20fashion%20manufacturing%20facility%2C%20sophisticated%20industrial%20looms%20with%20golden%20metallic%20details%20and%20emerald%20green%20accents%2C%20high-end%20fabric%20production%20equipment%20with%20dramatic%20cinematic%20lighting%2C%20elegant%20textile%20machinery%20in%20upscale%20atelier%20setting%20with%20rich%20textures%20and%20premium%20materials&width=1920&height=1080&seq=dluxmen-luxury-weaving&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
        </div>

        <div className="relative z-10 text-white text-center px-6 max-w-4xl mx-auto max-md:px-4">
          <h1 
            className="text-6xl md:text-8xl font-bold mb-6 max-md:text-4xl"
            style={{ fontFamily: 'Cinzel Decorative, serif' }}
          >
            DLUXMEN
          </h1>
          <p 
            className="text-2xl md:text-3xl mb-8 max-md:text-xl"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Onde Cada Detalhe Faz Diferença.
          </p>
          <button
            onClick={() => document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' })}
            className="px-12 py-4 text-lg font-semibold text-white rounded-lg transition-all duration-300 hover:bg-green-700 max-md:px-8 max-md:py-3 max-md:text-base"
            style={{ backgroundColor: '#0F3F2F' }}
          >
            Explorar Agora
          </button>
        </div>
      </section>

      {/* Category Filters */}
      <section className="py-8 border-b" style={{ backgroundColor: '#F8F8F8', borderColor: '#C0C0C0' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="flex items-center justify-center space-x-8 overflow-x-auto pb-2 max-md:space-x-4">
            {filters.map((filter) => (
              <button
                key={filter}
                onClick={() => setSelectedFilter(filter)}
                className={`text-sm font-medium uppercase tracking-wide whitespace-nowrap pb-2 border-b-2 transition-all duration-200 ${
                  selectedFilter === filter 
                    ? 'border-green-800 text-green-800' 
                    : 'border-transparent text-gray-600 hover:text-green-800'
                }`}
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                {filter}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Product Grid */}
      <section id="products" className="py-16 max-md:py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-md:gap-4">
            {featuredProducts.map((product) => (
              <ProductCard
                key={product.id}
                {...product}
                onClick={() => {
                  // Simular abertura de modal de produto
                  console.log('Produto clicado:', product.name);
                }}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Collections Section */}
      <section className="py-16 max-md:py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <h2 
            className="text-4xl font-bold text-center mb-12 max-md:text-2xl max-md:mb-8"
            style={{ 
              fontFamily: 'Cinzel Decorative, serif',
              color: '#0B0B0B'
            }}
          >
            Coleções Exclusivas
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-md:gap-6">
            {collections.map((collection, index) => (
              <div 
                key={index}
                className="group relative overflow-hidden rounded-lg cursor-pointer transition-all duration-300 hover:shadow-xl"
                onClick={() => window.location.href = collection.link}
              >
                <div className="aspect-[4/3] relative">
                  <img 
                    src={collection.image}
                    alt={collection.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>
                  
                  <div className="absolute bottom-6 left-6 text-white max-md:bottom-4 max-md:left-4">
                    <h3 
                      className="text-2xl font-bold mb-2 max-md:text-xl"
                      style={{ fontFamily: 'Cinzel Decorative, serif' }}
                    >
                      {collection.title}
                    </h3>
                    <p 
                      className="text-lg max-md:text-base"
                      style={{ 
                        fontFamily: 'Montserrat, sans-serif',
                        color: '#F8F8F8'
                      }}
                    >
                      {collection.subtitle}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About DLUXMEN Section */}
      <section className="py-16 max-md:py-12" style={{ backgroundColor: '#F8F8F8' }}>
        <div className="container mx-auto px-6 max-md:px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 
              className="text-4xl font-bold mb-6 max-md:text-2xl"
              style={{ 
                fontFamily: 'Cinzel Decorative, serif',
                color: '#0B0B0B'
              }}
            >
              Sobre a DLUXMEN
            </h2>
            <div 
              className="w-24 h-1 mx-auto mb-8"
              style={{ backgroundColor: '#0F3F2F' }}
            ></div>
            <p 
              className="text-lg leading-relaxed max-md:text-Base"
              style={{ 
                color: '#333333',
                fontFamily: 'Montserrat, sans-serif'
              }}
            >
              DLUXMEN é onde o luxo encontra a autenticidade. Do Brás — a capital da moda — para o mundo. 
              Cada peça é selecionada com precisão, combinando exclusividade e artesanato. 
              Mais que uma marca, somos um movimento que transforma empreendedores em referências de estilo.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-12 max-md:gap-6 max-md:mt-8">
              <div className="text-center">
                <div 
                  className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center max-md:w-12 max-md:h-12"
                  style={{ backgroundColor: '#0F3F2F' }}
                >
                  <i className="ri-award-line text-2xl text-white max-md:text-xl"></i>
                </div>
                <h3 
                  className="text-xl font-bold mb-2 max-md:text-lg"
                  style={{ 
                    fontFamily: 'Cinzel Decorative, serif',
                    color: '#0B0B0B'
                  }}
                >
                  Qualidade Premium
                </h3>
                <p 
                  className="text-sm"
                  style={{ 
                    color: '#C0C0C0',
                    fontFamily: 'Montserrat, sans-serif'
                  }}
                >
                  Super Clone 1.1 e 1.2 com materiais de primeira linha
                </p>
              </div>
              
              <div className="text-center">
                <div 
                  className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center max-md:w-12 max-md:h-12"
                  style={{ backgroundColor: '#0F3F2F' }}
                >
                  <i className="ri-truck-line text-2xl text-white max-md:text-xl"></i>
                </div>
                <h3 
                  className="text-xl font-bold mb-2 max-md:text-lg"
                  style={{ 
                    fontFamily: 'Cinzel Decorative, serif',
                    color: '#0B0B0B'
                  }}
                >
                  Entrega Nacional
                </h3>
                <p 
                  className="text-sm"
                  style={{ 
                    color: '#C0C0C0',
                    fontFamily: 'Montserrat, sans-serif'
                  }}
                >
                  Enviamos para todo o Brasil com segurança
                </p>
              </div>
              
              <div className="text-center">
                <div 
                  className="w-16 h-16 mx-auto mb-4 rounded-full flex items-center justify-center max-md:w-12 max-md:h-12"
                  style={{ backgroundColor: '#0F3F2F' }}
                >
                  <i className="ri-shield-check-line text-2xl text-white max-md:text-xl"></i>
                </div>
                <h3 
                  className="text-xl font-bold mb-2 max-md:text-lg"
                  style={{ 
                    fontFamily: 'Cinzel Decorative, serif',
                    color: '#0B0B0B'
                  }}
                >
                  Garantia Total
                </h3>
                <p 
                  className="text-sm"
                  style={{ 
                    color: '#C0C0C0',
                    fontFamily: 'Montserrat, sans-serif'
                  }}
                >
                  Troca fácil e atendimento especializado
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {/* Custom Styles */}
      <style jsx>{`
        .line-clamp-2 {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>
  );
}

export default HomePage;
